import { useQuery } from '@tanstack/react-query';

import { getFutureMeetingsRequest } from '../../requests';

export const useFutureMeetingsQuery = (
  userId: string,
  companyId: string,
  search: string,
  page: string,
) => {
  return useQuery({
    queryKey: ['getFutureMeetings', userId, companyId, search, page],
    queryFn: () => getFutureMeetingsRequest(userId, companyId, search, page),
    refetchOnWindowFocus: false,
  });
};
